<script setup lang="ts">
import {SharingStatus} from "@/core/interfaces/Sharing";

defineProps<{
    status: SharingStatus
}>();
</script>

<template>
  <span v-if="status === SharingStatus.AUTHORIZED" class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
    Autorisé
  </span>
  <span v-else-if="status === SharingStatus.PENDING" class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
    En attente
  </span>
  <span v-else-if="status === SharingStatus.DECLINED" class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
    Refusé
  </span>
</template>

<style scoped>

</style>
